// Didit status + our id_verification_status -> one label for clients and staff.
const C = {
  ok: 'bg-green-100 text-green-800', manual: 'bg-teal-100 text-teal-800', warn: 'bg-amber-100 text-amber-800',
  info: 'bg-blue-100 text-blue-800', bad: 'bg-red-100 text-red-800', muted: 'bg-muted text-muted-foreground',
};
const DIDIT = {
  'Approved': ['Approved', C.ok], 'In Review': ['In review', C.warn], 'In Progress': ['In progress', C.info],
  'Awaiting User': ['In progress', C.info], 'Resubmitted': ['In review', C.warn], 'Declined': ['Declined', C.bad],
  'Expired': ['Expired', C.muted], 'Kyc Expired': ['Expired', C.muted], 'Abandoned': ['Expired', C.muted], 'Not Started': ['Not started', C.muted],
};
export const IDV_RETRY = ['Declined', 'Expired', 'Kyc Expired', 'Abandoned'];

export const idvMeta = (diditStatus, idStatus, manual) => {
  if (idStatus === 'verified_manual') return { label: 'Manually verified', color: C.manual, detail: manual ? `Manually verified by ${manual.by_name} – ${manual.reason}` : null, ok: true };
  if (idStatus === 'not_required') return { label: 'Not required (existing client)', color: C.muted, ok: true };
  const [label, color] = DIDIT[diditStatus] || DIDIT['Not Started'];
  return { label, color, ok: diditStatus === 'Approved' || idStatus === 'verified', retry: IDV_RETRY.includes(diditStatus) };
};
